export default __webpack_public_path__ + "static/media/13_photo.e7f1f917.jpg";